module.exports = __webpack_public_path__ + "bodylabs-84b61436.png";